export default "../images/stackloans-partners-with-LendingClub_PORTAL_US.png?cd6d7cb35b2b71183012197d08acbb95";